var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebpos({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 67.6,
    height: 67.7,
    viewBox: "0 0 67.6 67.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 9.91,
    y1: 57.74,
    x2: 57.69,
    y2: 9.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9f48a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d163ab"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.8,67.7A33.85,33.85,0,1,0,0,33.8,33.82,33.82,0,0,0,33.8,67.7Z",
    fillRule: "evenodd",
    fill: "url(#a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.72,21.88A8.8,8.8,0,0,0,44,19.11V13.7a2.23,2.23,0,0,0-2.25-2.15H26a2.18,2.18,0,0,0-2.25,2.15v5.47a8.53,8.53,0,0,0-4.55,2.68,7.7,7.7,0,0,0-1.29,6.8l2,7.68V50.44a4,4,0,0,0,1,2.92,4.06,4.06,0,0,0,3,1.29H43.8A4.2,4.2,0,0,0,48,50.5V36.33l2-7.68A8,8,0,0,0,48.72,21.88Zm-7.27-3.34A39.41,39.41,0,0,0,37,18v-4h4.5Zm-15.2-4.49h8.2v3.88H34a45.21,45.21,0,0,0-7.7.65Zm20.36,13.7-2.1,7.9a1.74,1.74,0,0,0-.06.45V50.5a.69.69,0,0,1-.65.65H24a.57.57,0,0,1-.44-.17.44.44,0,0,1-.12-.35.57.57,0,0,0,0-.13V36.1a1.74,1.74,0,0,0-.06-.45l-2.1-7.9A4.24,4.24,0,0,1,22,23.92c.89-1.22,5.59-2.5,11.93-2.5h0c6.34,0,11,1.28,11.91,2.47A4.53,4.53,0,0,1,46.61,27.75ZM40.1,24.5H27.6a3,3,0,0,0-3,3v4.2a3,3,0,0,0,3,3H40.1a3,3,0,0,0,3-3V27.5A3,3,0,0,0,40.1,24.5Zm0,7.2H27.6l0-4.2H40.1Zm-9.9,8.5a1.9,1.9,0,1,1-1.9-1.9A1.9,1.9,0,0,1,30.2,40.2Zm5.5,0a1.9,1.9,0,1,1-1.9-1.9A1.9,1.9,0,0,1,35.7,40.2Zm5.6,0a1.84,1.84,0,0,1-1.9,1.9,1.9,1.9,0,0,1,0-3.8A2,2,0,0,1,41.3,40.2ZM30.2,45.6a1.9,1.9,0,1,1-1.9-1.9A1.84,1.84,0,0,1,30.2,45.6Zm5.5,0a1.84,1.84,0,0,1-1.9,1.9,1.9,1.9,0,1,1,0-3.8A1.84,1.84,0,0,1,35.7,45.6Zm5.6,0a1.84,1.84,0,0,1-1.9,1.9,1.9,1.9,0,1,1,1.9-1.9Z",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebpos);
export default __webpack_public_path__ + "static/media/webpos.88f09dd8bbf2ef35de0e98246589da6c.svg";
export { ForwardRef as ReactComponent };